import { exit } from 'process';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Container, Row, Col, Button, Modal, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import verify_img from "../../images/verify_img.png";
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import { RootState } from '../store';
import { useDispatch, useSelector } from 'react-redux';
import { setEmail, setResetPasswordWizardPageNumber } from '../ResetPasswordReducer';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import { sendOtp } from '../../Utils/otp';


type MyComponentProps = {
    videoConstraints?: any;
    show: boolean;
    handleClose: () => void;
    title: String;
    ref?: any;
    side: String;
    updateSrc: (srcString: any) => void;
};

const SendOTPModal = (props: MyComponentProps) => {
    const { t } = useTranslation();
    const [validated, setValidated] = useState(false);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const email = useSelector((state: RootState) => state.auth.email);

    const page = useSelector((state: RootState) => state.resetPassword.wizardPageNumber);

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const startLoading = () => {
        setLoading(true);
    };

    const handleSendOtp = async (event: any) => {
        event.preventDefault();
        setIsSubmitted(true);
        startLoading();
        try {
            const data = await sendOtp(email);
            if (data?.status === 1) {
                notifySuccess('OTP Sent');
                dispatch(setEmail(email));
                dispatch(setResetPasswordWizardPageNumber(page + 1));
            } else {
                notifyError('Something Went Wrong');
            }
        } catch (error: any) {
            console.error(error);
            notifyError('Something Went Wrong');
        }
        setIsSubmitted(false);
    };

    return (
        <>
            <Modal show={props.show} onHide={props.handleClose} ref={props.ref}>
                <Modal.Body className='p-3'>
                    <Form noValidate validated={validated}>
                        <div className='row mt-2 text-center d-flex flex-column align-items-center'>
                            <img className='w-25 mb-1' src={verify_img} alt="Verification" />
                            <label className='mb-1 mt-3'>{t('camera.send_otp')}</label>
                            <Col md={8}>
                                <Button variant="primary" type="submit" className="btn btn-primary rounded-5 mt-3" onClick={(event) => { handleSendOtp(event); }} disabled={(loading && isSubmitted)}>
                                    {loading && isSubmitted && (
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='mx-2'
                                        />
                                    )}
                                    <span>{t('camera.send_otp_btn')}</span>
                                </Button>{' '}
                            </Col>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default SendOTPModal;
